import { render } from "./test-cate.vue?vue&type=template&id=afcc87bc&scoped=true"
import script from "./test-cate.vue?vue&type=script&lang=js"
export * from "./test-cate.vue?vue&type=script&lang=js"

import "./test-cate.vue?vue&type=style&index=0&id=afcc87bc&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afcc87bc"]])

export default __exports__